import { DataTypeCategoryData, DataTypeData } from "./data-type-selector";
import {
  ActionListItemGroup,
  ActionListModel
} from "@genexus/chameleon-controls-library/dist/types/components/action-list/types";

export const mapCategoryToListItemGroup = (
  category: DataTypeCategoryData
): ActionListItemGroup => {
  const categoryGroup: ActionListItemGroup = {
    caption: category.name,
    id: category.name,
    type: "group",
    expanded: true,
    expandable: true,
    items: category.types.map(type => {
      return {
        caption: type.name,
        id: type.name,
        selected: type.selected,
        additionalInformation: {
          "stretch-start": {
            center: [{ imgSrc: type.icon }]
          }
        },
        type: "actionable"
      };
    })
  };
  return categoryGroup;
};

export const mapDataTypesToList = (
  dataTypes: DataTypeData[]
): ActionListModel => {
  return dataTypes.map((dataType, index) => {
    return {
      caption: dataType.name,
      id: dataType.name,
      selected: dataType.selected,
      additionalInformation: {
        "stretch-start": {
          center: [{ imgSrc: dataType.icon || undefined }]
        }
      },
      type: "actionable",
      order: index
    };
  });
};
